import React from "react";
import { Icon, Popover } from "@clarkinc/zest-design-system";
import { ClientOnly } from "@wss/react";
interface Props {
  id: string;
  title: string;
  content: string;
}
const MemberPricePopover = ({
  id,
  title,
  content
}: Props) => {
  return <ClientOnly data-sentry-element="ClientOnly" data-sentry-component="MemberPricePopover" data-sentry-source-file="MemberPricePopover.tsx">
      <Popover className="!absolute right-1 top-1" onHover contentProps={{
      id
    }} data-sentry-element="Popover" data-sentry-source-file="MemberPricePopover.tsx">
        <Popover.Trigger contentId={id} data-sentry-element="unknown" data-sentry-source-file="MemberPricePopover.tsx">
          <Icon name="ri-question-fill" aria-label="more information" className="fill-slate-400 w-3.5 h-3.5" data-sentry-element="Icon" data-sentry-source-file="MemberPricePopover.tsx" />
        </Popover.Trigger>
        <Popover.Content id={id} placement="top" title={title} data-sentry-element="unknown" data-sentry-source-file="MemberPricePopover.tsx">
          {content}
        </Popover.Content>
      </Popover>
    </ClientOnly>;
};
export default MemberPricePopover;